// src/ResultModal.js
import React, { useEffect, useState } from "react";
import { apiFetch } from "./api";
import { downloadFileWithAuth } from "./downloadWithAuth";

export default function ResultModal({ commandId, onClose }) {
  const [result, setResult] = useState(null);

  useEffect(() => {
    apiFetch(`/command_result/${commandId}`).then(data => setResult(data));
  }, [commandId]);

  if (!result)
    return (
      <div className="modal">
        <div className="modal-content">Loading...</div>
      </div>
    );

  const { result: res, files } = result;

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="close" onClick={onClose}>
          ×
        </button>
        <h4>Command Result</h4>
        <pre>{JSON.stringify(res, null, 2)}</pre>
        {files && files.length > 0 && (
          <div>
            <h5>Files</h5>
            <ul>
              {files.map(f => (
                <li key={f.id}>
                  <button
                    onClick={() => downloadFileWithAuth(f.id, f.filename)}
                    style={{ cursor: "pointer" }}
                  >
                    {f.filename} ({f.filesize} bytes)
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
